import { EnterpriseEndpoints } from '../../../utils/endpoints';
import PageHeader from '../../shell/PageHeader';
import TransactionsTable from './enterprise/TransactionsTable';
import useStores from './enterprise/useStores';

const breadcrumbs = [{ label: 'Home', to: '/layout' }, { label: 'Transactions' }];

const EnterpriseTransactions = () => {
  const stores = useStores();

  return (
    <>
      <PageHeader title="Transactions" breadcrumbs={breadcrumbs} />
      <TransactionsTable
        endpoint={EnterpriseEndpoints.transactions}
        exportEndpoint={EnterpriseEndpoints.transactionsExport}
        showStore
        stores={stores}
      />
    </>
  );
};

export default EnterpriseTransactions;
